let OrderForm = require('./orderForm');

function init() {

  let orderForm = document.querySelector('[data-order-form]');
  if (orderForm) {
    new OrderForm({
      elem: orderForm
    });
  }

}

init();
